"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApSimpleTableBodyCell = exports.ApSimpleTableHeadCell = exports.ApSimpleTableRow = exports.ApSimpleTableBody = exports.ApSimpleTableHead = exports.ApSimpleTable = void 0;
var React = require("react");
var theme_1 = require("../../utils/theme");
var types_1 = require("../../utils/types");
var styles_1 = require("./styles");
exports.ApSimpleTable = function (_a) {
    var children = _a.children, className = _a.className, tableHeight = _a.tableHeight, tableBorders = _a.tableBorders, bodyOffset = _a.bodyOffset, tableMinWidth = _a.tableMinWidth, tableWidth = _a.tableWidth;
    return (React.createElement(styles_1.StyledTableSection, { className: "ap-simple-table-section " + (className ? className : ''), bodyOffset: bodyOffset, tableBorders: tableBorders, tableMinWidth: tableMinWidth, tableWidth: tableWidth },
        React.createElement(styles_1.StyledTableContainer, { className: "ap-simple-table-container", tableHeight: tableHeight },
            React.createElement(styles_1.StyledTable, { tableMinWidth: tableMinWidth, tableWidth: tableWidth, className: "ap-simple-table" }, children))));
};
exports.ApSimpleTableHead = function (_a) {
    var children = _a.children;
    return (React.createElement(styles_1.StyledTableHead, { className: "ap-simple-table-head" }, children));
};
exports.ApSimpleTableBody = function (_a) {
    var children = _a.children;
    return (React.createElement(styles_1.StyledTableBody, { className: "ap-simple-table-body" }, children));
};
exports.ApSimpleTableRow = function (_a) {
    var children = _a.children;
    return (React.createElement(styles_1.StyledTableRow, { className: "ap-simple-table-row" }, children));
};
exports.ApSimpleTableHeadCell = function (_a) {
    var className = _a.className, children = _a.children, cellWidth = _a.cellWidth, cellMinWidth = _a.cellMinWidth, cellTextColor = _a.cellTextColor;
    return (React.createElement(styles_1.StyledTableHeadCell, { className: "ap-simple-table-head-cell" + (className ? className : ''), cellWidth: cellWidth, cellMinWidth: cellMinWidth, cellTextColor: cellTextColor },
        React.createElement(styles_1.StyledTableHeadCellInner, { className: "ap-simple-table-head-cell-inner " + (className ? className : ''), cellWidth: cellWidth, cellMinWidth: cellMinWidth, cellTextColor: cellTextColor }, children)));
};
exports.ApSimpleTableBodyCell = function (_a) {
    var className = _a.className, children = _a.children, cellBorders = _a.cellBorders, cellWidth = _a.cellWidth, cellMinWidth = _a.cellMinWidth, cellTextColor = _a.cellTextColor;
    return (React.createElement(styles_1.StyledTableBodyCell, { className: "ap-simple-table-body-cell " + (className ? className : ''), cellBorders: cellBorders, cellWidth: cellWidth, cellMinWidth: cellMinWidth, cellTextColor: cellTextColor }, children));
};
exports.ApSimpleTable.defaultProps = {
    bodyOffset: theme_1.scaffolding.xl,
    tableBorders: (_a = {},
        _a[types_1.TOP] = false,
        _a[types_1.LEFT] = false,
        _a[types_1.BOTTOM] = false,
        _a[types_1.RIGHT] = false,
        _a),
    tableHeight: '297px',
    tableMinWidth: '280px',
    tableWidth: '100%'
};
exports.ApSimpleTableHeadCell.defaultProps = {
    cellTextColor: theme_1.colors.grey5
};
exports.ApSimpleTableBodyCell.defaultProps = {
    cellBorders: (_b = {}, _b[types_1.TOP] = false, _b[types_1.LEFT] = false, _b[types_1.BOTTOM] = false, _b[types_1.RIGHT] = false, _b),
    cellTextColor: theme_1.colors.grey8
};
//# sourceMappingURL=ApSimpleTable.js.map